// @pages/VideoSummaryPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import "@styles/pages/GenericPage/VideoBlogSummaryPage/VideoBlogSummaryPage.scss";
import { getVideoList } from "@api/landingApi";
import { getOptionData } from "@api/commonApi";
import { videoFilterData } from "@data/FilterData";
import SummaryCardList from "@pages/GenericPage/VideoBlogSummaryPage/SummaryCardList";
import { Box, Typography } from "@mui/material";
import { Trans } from "react-i18next";

export default function VideoSummaryPage() {
  const [videoCardList, setVideoCardList] = useState([]);
  const [videoFilterOptions, setVideoFilterOptions] = useState({});

  const combinedVideoFilterList = useMemo(() => [...videoFilterData], []);

  useEffect(() => {
    (async () => {
      try {
        const res = await getVideoList();
        setVideoCardList(res.data.Data || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const result = {};
      for (const f of combinedVideoFilterList) {
        try {
          if (f.staticOptions) {
            result[f.type] = f.staticOptions;
          } else {
            const res = await getOptionData({ type: f.type });
            result[f.type] = res?.data?.Data || [];
          }
        } catch (e) {
          console.error("Failed to fetch", f.type, e);
        }
      }
      setVideoFilterOptions(result);
    })();
  }, [combinedVideoFilterList]);

  return (
    <Box className="video-blog-summary-page-container">
      <Box className="title-container">
        <Typography className="title">
          <Trans i18nKey="generic:latest_video" />
        </Typography>
    
      </Box>

      <SummaryCardList
        cardType="video"
        filterData={combinedVideoFilterList}
        filterOptions={videoFilterOptions}
        cardList={videoCardList}
      />
    </Box>
  );
}
